<template>
    <div class="row g-5 mb-5">
        <div class="col-12" v-if="locations">
            <label class="form-label" for="location">
                {{ $trans.get('__JSON__.Location') }}
            </label>
            <v-select v-model="formData.location" :options="locations" :reduce="item => item.code" :class="{ 'is-invalid': this.hasError('location') }" />
            <span class="invalid-feedback" role="alert" v-if="this.hasError('location')">
                <strong>{{ this.getError('location') }}</strong>
            </span>
        </div>
        <div class="col-12" v-if="showSection('employees')">
            <label class="form-label" for="employee">
                {{ $trans.get('__JSON__.Employee') }}
            </label>
            <v-select v-model="formData.employee" :options="employees" :reduce="item => item.code" :class="{ 'is-invalid': this.hasError('employee') }" />
            <span class="invalid-feedback" role="alert" v-if="this.hasError('employee')">
                <strong>{{ this.getError('employee') }}</strong>
            </span>
        </div>
        <div class="col-12" v-if="showSection('start_date')">
            <label class="form-label" for="start_date">
                {{ $trans.get('__JSON__.Start Date') }}
            </label>
            <input type="date" name="start_date" class="form-control" :class="{ 'is-invalid': this.hasError('startDate') }" id="start_date" v-model="formData.startDate">
            <span class="invalid-feedback" role="alert" v-if="this.hasError('startDate')">
                <strong>{{ this.getError('startDate') }}</strong>
            </span>
        </div>
        <div class="col-12" v-if="showSection('end_date')">
            <label class="form-label" for="end_date">
                {{ $trans.get('__JSON__.End Date') }}
            </label>
            <input type="date" name="end_date" class="form-control" :class="{ 'is-invalid': this.hasError('endDate') }" id="end_date" v-model="formData.endDate">
            <span class="invalid-feedback" role="alert" v-if="this.hasError('endDate')">
                <strong>{{ this.getError('endDate') }}</strong>
            </span>
        </div>

        <div class="col-12" v-if="showSection('employment')">
            <label class="form-label" for="employment">
                {{ $trans.get('__JSON__.Employment') }}
            </label>
            <v-select v-model="formData.employment" :options="employments" :reduce="item => item.code" :class="{ 'is-invalid': this.hasError('employment') }" />
            <span class="invalid-feedback" role="alert" v-if="this.hasError('employment')">
                <strong>{{ this.getError('employment') }}</strong>
            </span>
        </div>
        <div class="col-12" v-if="showSection('employment_type')">
            <label class="form-label" for="employment_type">
                {{ $trans.get('__JSON__.Employment type') }}
            </label>
            <v-select v-model="formData.employmentType" :options="employmentTypes" :reduce="item => item.code" :class="{ 'is-invalid': this.hasError('employmentType') }" />
            <span class="invalid-feedback" role="alert" v-if="this.hasError('employmentType')">
                <strong>{{ this.getError('employmentType') }}</strong>
            </span>
        </div>

        <div class="col-12" v-if="showSection('placement_function')">
            <label class="form-label" for="placement_function">
                {{ $trans.get('__JSON__.Function') }}
            </label>
            <v-select v-model="formData.placementFunction" :options="placementFunctions" :reduce="item => item.code" :class="{ 'is-invalid': this.hasError('placementFunction') }" />
            <span class="invalid-feedback" role="alert" v-if="this.hasError('placementFunction')">
                <strong>{{ this.getError('placementFunction') }}</strong>
            </span>
        </div>
        <div class="col-12" v-if="showSection('phase')">
            <label class="form-label" for="phase">
                {{ $trans.get('__JSON__.Phase') }}
            </label>
            <v-select v-model="formData.phase" :options="phases" :reduce="item => item.code" :class="{ 'is-invalid': this.hasError('phase') }" />
            <span class="invalid-feedback" role="alert" v-if="this.hasError('phase')">
                <strong>{{ this.getError('phase') }}</strong>
            </span>
        </div>
        <div class="col-12" v-if="showSection('employment_method')">
            <label class="form-label" for="temporaryEmploymentMethod">
                {{ $trans.get('__JSON__.Temporary employment method') }}
            </label>
            <v-select v-model="formData.temporaryEmploymentMethod" :options="temporaryEmploymentMethods" :reduce="item => item.code" :class="{ 'is-invalid': this.hasError('temporaryEmploymentMethod') }" />
            <span class="invalid-feedback" role="alert" v-if="this.hasError('temporaryEmploymentMethod')">
                <strong>{{ this.getError('temporaryEmploymentMethod') }}</strong>
            </span>
        </div>
        <div class="col-12" v-if="showSection('placement_type')">
            <label class="form-label" for="placementType">
                {{ $trans.get('__JSON__.Type of placement') }}
            </label>
            <v-select v-model="formData.placementType" :options="placementTypes" :reduce="item => item.code" :class="{ 'is-invalid': this.hasError('placementType') }" />
            <span class="invalid-feedback" role="alert" v-if="this.hasError('placementType')">
                <strong>{{ this.getError('placementType') }}</strong>
            </span>
        </div>
        <div class="col-12" v-if="showSection('probation')">
            <label class="form-label" for="probation">
                {{ $trans.get('__JSON__.Probation') }}
            </label>
            <v-select v-model="formData.probation" :options="probations" :reduce="item => item.code" :class="{ 'is-invalid': this.hasError('probation') }" />
            <span class="invalid-feedback" role="alert" v-if="this.hasError('probation')">
                <strong>{{ this.getError('probation') }}</strong>
            </span>
        </div>
        <div class="col-12" v-if="showSection('message')">
            <label for="message" class="form-label">
                {{ $trans.get('__JSON__.Message') }} ({{ $trans.get('__JSON__.optional') }})
            </label>
            <textarea name="message" class="form-control" :class="{ 'is-invalid': this.hasError('message') }" id="message" rows="5" v-model="formData.message"></textarea>
            <span class="invalid-feedback" role="alert" v-if="this.hasError('message')">
                <strong>{{ this.getError('message') }}</strong>
            </span>
        </div>
    </div>
    <div class="d-flex justify-content-center" v-if="fetching">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">{{ $trans.get('__JSON__.Loading...') }}</span>
        </div>
    </div>
</template>

<script>
import RequestHandler from '../../mixins/RequestHandler'
import vSelect from 'vue-select'

export default {
    name: 'ContractForm',
    mixins: [ RequestHandler ],
    components: { vSelect },
    data() {
        return {
            fetching: false,

            formData: {
                location: this.$parent.$data.data.location,
                employee: this.$parent.$data.data.employee,
                employment: this.$parent.$data.data.employment,
                employmentType: this.$parent.$data.data.employmentType,
                startDate: this.$parent.$data.data.startDate,
                endDate: this.$parent.$data.data.endDate,
                contractType: this.$parent.$data.data.type,
                placementFunction: this.$parent.$data.data.placementFunction,
                phase: this.$parent.$data.data.phase,
                placementType: this.$parent.$data.data.placementType,
                temporaryEmploymentMethod: this.$parent.$data.data.temporaryEmploymentMethod,
                probation: this.$parent.$data.data.probation,
                message: null,
            },

            action: this.$parent.$data.action,
            locations: this.$parent.$data.data.locations,
            employees: this.$parent.$data.data.employees,
            employments: this.$parent.$data.data.employments,
            employmentTypes: this.$parent.$data.data.employmentTypes,
            placementFunctions: this.$parent.$data.data.placementFunctions,
            phases: this.$parent.$data.data.phases,
            placementTypes: this.$parent.$data.data.placementTypes,
            temporaryEmploymentMethods: this.$parent.$data.data.temporaryEmploymentMethods,
            probations: this.$parent.$data.data.probations,
        }
    },
    watch: {
        'formData.location'() {
            this.formData.employee = null
            this.$parent.$data.data.employee = null
            if (this.action === 'create') this.fetchLocationEmployees()
        },
        'formData.employee'() {
            if (this.action === 'create' && this.formData.employee) {
                this.$parent.$data.data.employee = this.formData.employee

                // set default values when creating placement
                this.formData.phase = 'A' // Fase A
                this.formData.temporaryEmploymentMethod = 'U' // Uitzenden
                this.formData.placementType = 'F' // Fase A/1-2
                this.formData.probation = '1M' // Een Maand
            }
        },
    },
    methods: {
        showSection(section) {
            const contractType = this.$parent.$data.data.contractType

            if (this.action === 'create') {
                if (['employment', 'employment_type'].includes(section)) return false
                else return ((section === 'employees' && this.formData.location && ! this.fetching) || (section !== 'employees' && this.formData.employee))
            }

            else if (['start_date', 'end_date', 'probation', 'message', 'employees'].includes(section)) return true

            else if (contractType === 'employment') {
                return [
                    'phase',
                    'employment',
                    'employment_type',
                ].includes(section)
            } else if (contractType === 'placement') {
                return [
                    'phase',
                    'placement_function',
                    'employment_method',
                    'placement_type',
                ].includes(section)
            }

            else return false
        },
        fetchLocationEmployees() {
            this.fetching = true

            this.makeRequest('post', '/api/contracts', {
                action: 'employees',
                location: this.formData.location,
            }, response => Object.assign(this.$data, this.$data, response.data),
            error => console.log(error),
            () => this.fetching = false
            )
        },
    },
}
</script>
